import { DTVendable } from '@rabbit/data/types';
import { FBF_CloudCallable } from '@rabbit/firebase/adapter';

export const nestApiUpdateVendableInAlgolia = FBF_CloudCallable<DTVendable, any>(
  'api/vendables/updateInAlgolia|POST'
);

export const nestApiUpdateMultipleVendablesInAlgolia = FBF_CloudCallable<DTVendable[], any>(
  'api/vendables/updateMultipleInAlgolia|POST'
);

export const nestApiDeleteVendable = FBF_CloudCallable<{ docid: string }, any>(
  'api/vendables/delete|POST'
);
